import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/ProductSearch';
import './ProductBoxes.css';
import NumberFormat from 'react-number-format';
import { Button } from 'react-bootstrap';

import 'font-awesome/css/font-awesome.min.css';
//import { ControlLabel, FormControl, FormGroup, Form, HelpBlock } from 'react-bootstrap';

export class ProductBoxes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPriceCalc: localStorage.getItem('Menu-PriceCalc') === 'true' || localStorage.getItem('Menu-PriceCalc') === true,
        }
    }
    componentWillMount() {
        // This method runs when the component is first added to the page
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    render() {
        const products = this.props.productData.length > 0;

        if (products) {
            return (
                <div>
                    {this.props.productData.map(product =>
                        <div key={product.Id + '/' + product.UnitOfMeasure} className='epc-product-box'>
                            <p class="product-search-name">
                                <a href={'http://www.empirepaper.com/ItemDisplayF.aspx?ItemId=' + product.Id} target="_blank">
                                    {product.BrandName}&nbsp;{product.WebName}
                                </a>
                            </p>
                            <p>{product.Id + ' - ' + product.Availability + ' - ' + product.QuantityOnHand + ' ' + product.UnitOfMeasure}</p>
                            <NumberFormat value={product.Price} thousandSeparator={true}
                                displayType={'text'} prefix={'$'} className='product-price'
                                fixedDecimalScale={true} decimalScale={2} />

                            <img src={product.ImagePath} alt={product.WebName} />
                            <ul>
                                {product.SellingPoints.map(sellingPoint =>
                                    <li>{sellingPoint}</li>
                                )}
                            </ul>
                            <Button bsStyle="success" bsSize="xsmall" className={this.state.showPriceCalc === true ? 'calculatorButton' : 'hidden'} onClick={() => {
                                localStorage.setItem('selectedProduct', product.Id);
                                localStorage.setItem('selectedProductUM', product.UnitOfMeasure);

                                this.setState((state, props) => {
                                    return { selectedProduct: localStorage.getItem('selectedProduct') };
                                });

                                this.setState((state, props) => {
                                    return { selectedProduct: localStorage.getItem('selectedProductUM') };
                                });

                                window.open('/pricing-calculator', '_self');
                            }}>
                                <i className={'fa fa-calculator'}></i> Calculator
                            </Button>
                            <hr />
                        </div>
                    )}
                    
                </div>
            );
        } else {
            return '';
        }
    }
}

export default connect(
    state => state.productSearch,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ProductBoxes);


// WEBPACK FOOTER //
// ./src/components/product/ProductBoxes.js